import { Link } from "react-router-dom";
import CheckoutFlow from "./components/CheckoutFlow";
import { useStore } from "@/store/StoreContext";

export default function CheckoutPage() {
  const { cart } = useStore();

  if (!cart.length) {
    return (
      <section className="w-full px-4 py-20 md:px-8 md:py-28">
        <div className="mx-auto flex max-w-lg flex-col items-center text-center">
          <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-50 text-primary-600">
            <i className="ri-shopping-bag-3-line text-4xl" />
          </span>
          <h1 className="mt-6 font-heading text-3xl text-foreground-900">Sua sacola está vazia</h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            Escolha suas peças favoritas e volte aqui para finalizar seu pedido.
          </p>
          <Link
            to="/novidades"
            className="mt-7 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            Ver produtos
          </Link>
        </div>
      </section>
    );
  }

  return <CheckoutFlow items={cart} />;
}